import React from "react";
import styled from "styled-components";

const BoxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.bg};
  border-radius: 5px;
  padding: 10px;
  text-align: center;
  p {
    font-size: 14px;
    letter-spacing: 0.2px;
  }
`;

const NotOpenTo = ({ bg = "#FFC7D5", text, cls = "" }) => {
  return (
    <BoxWrapper className={`${cls} _spNotOpenPos`} bg={bg}>
      <p>
        {text ??
          "This position is not open to you. If you think it should, discuss with your account manager."}
      </p>
    </BoxWrapper>
  );
};

export default NotOpenTo;
